module.exports = __webpack_public_path__ + "img/電気回路_1_9_1.f2f6e20c.png";